import ConfirmationWorklist from '@/screens/ConfirmationWorklist';

/**
 * The ONE Confirmations screen (tv-2na.11.2): the sequence-first worklist. The
 * old day-strip screen and its Current/New toggle are retired.
 */
export default function ConfirmationsRoute() {
  return <ConfirmationWorklist />;
}
